import PropTypes from 'prop-types';
import React from 'react';
import { Typography, Grid } from '@material-ui/core';

export default function DataRow({ label, order, estimate, invoice, index }) {
  return (
    <Grid container direction="row-reverse">
      <Grid item xs={3}>
        <Typography
          variant="caption"
          modifiers="fontWeightLight"
          id={`${label}Supplied${index}`}
        >
          {invoice}
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography
          variant="caption"
          modifiers="fontWeightLight"
          id={`${label}Agreed${index}`}
        >
          {estimate}
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography
          variant="caption"
          modifiers="fontWeightLight"
          id={`${label}Requested${index}`}
        >
          {order}
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="subtitle2" modifiers="fontWeightMedium">
          {label}
        </Typography>
      </Grid>
    </Grid>
  );
}

DataRow.propTypes = {
  label: PropTypes.string.isRequired,
  index: PropTypes.string.isRequired,
  order: PropTypes.string,
  estimate: PropTypes.string,
  invoice: PropTypes.string,
};

DataRow.defaultProps = {
  order: '',
  estimate: '',
  invoice: '',
};
